import { AgencyFormData } from '../screens/General/screens/AgencyInfo/components/AgencyForm';
import { IAgencyInfo } from '../types/app';

const groupInfo = (dataForm: Partial<AgencyFormData>): Partial<IAgencyInfo> => {
    const {
        exigentHours,
        exigentAmount,
        logoDocName,
        logoDocMimeType,
        logoDoc,
        logoDocFile,
        created,
        updated,
        deleted,
        ...data
    } = dataForm;

    const hours: number = exigentHours ? +Number(exigentHours) : 0;
    const amount: number = exigentAmount ? +Number(exigentAmount) : 0;

    const dataSend: Partial<IAgencyInfo> = {
        ...data,
        ...{
            exigentHours: hours,
            exigentAmount: amount,
        },
    };
    return dataSend;
};
export { groupInfo };
